(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfMentionSelection', function() {
    return {
      restrict: 'A',
      require: '^mfMentionContainer',
      scope: {
        mention: '='
      },
      link: (function(_this) {
        return function(scope, elem, attrs, Cont) {
          var mention;
          mention = scope.mention;
          return elem.on('click', function() {
            var fnd, mention_id, new_text, old_text, rpl;
            mention_id = mention.user_records_id;
            rpl = mention.username + ' ';
            if ((Cont.get('pattern') != null) && Cont.get('pattern') !== '') {
              old_text = Cont.get('text');
              fnd = '@' + Cont.get('pattern');
              new_text = old_text.replace(fnd, '@' + rpl);
              Cont.setText(new_text);
            } else {
              Cont.setText(Cont.get('text') + rpl);
            }
            Cont.setPattern(null, false);
            return angular.element(Cont.input_elem).trigger('focus');
          });
        };
      })(this)
    };
  });

}).call(this);
